<template>
  <span :title="methodLabel" :aria-label="methodLabel" role="img">
    <span v-if="method === 'CREDIT_CARD'">
      <i class="fas fa-credit-card text-success"></i>
    </span>
    <span v-else-if="method === 'TWO_CREDIT_CARD' || method === 'TWO_CREDIT_CARDS'">
      <i class="fas fa-credit-card text-success mr-1"></i>
      <i class="fas fa-credit-card text-success"></i>
    </span>
    <span v-else-if="method === 'BOLETO'">
      <i class="fas fa-ticket-alt text-info"></i>
    </span>
    <span v-else-if="method === 'PIX'">
      <i class="fas fa-qrcode text-secondary"></i>
    </span>
    <span v-else-if="method === 'PAYPAL'">
      <i class="fab fa-paypal text-dark"></i>
    </span>
    <span v-else-if="method === 'GOOGLE_PAY'">
      <i class="fab fa-google text-dark mr-1"></i><b>Pay</b>
    </span>
    <span v-else-if="method === 'APPLE_PAY'">
      <i class="fab fa-apple-pay fa-2x text-dark"></i>
    </span>
    <span v-else class="text-muted">
      <i class="fas fa-money-bill-alt"></i>
    </span>
  </span>
</template>

<script>
export default {
  name: 'PaymentMethodIcon',
  props: {
    method: {
      type: String,
      default: null,
      validator(value) {
        return value === null || value === undefined || value === '' || [
          'CREDIT_CARD',
          'TWO_CREDIT_CARD',
          'TWO_CREDIT_CARDS',
          'BOLETO',
          'PIX',
          'PAYPAL',
          'GOOGLE_PAY',
          'APPLE_PAY',
        ].includes(value);
      },
    },
  },
  computed: {
    methodLabel() {
      const labels = {
        CREDIT_CARD: 'Cartão de crédito',
        TWO_CREDIT_CARD: 'Dois cartões',
        TWO_CREDIT_CARDS: 'Dois cartões',
        BOLETO: 'Boleto',
        PIX: 'Pix',
        PAYPAL: 'PayPal',
        GOOGLE_PAY: 'Google Pay',
        APPLE_PAY: 'Apple Pay',
      }
      return labels[this.method] || 'Método de pagamento'
    },
  },
}
</script>
